import { array } from 'prop-types';
import React, { Fragment, useState } from 'react';
import { translate } from '../../Services/translation';
import BrandsResults from './BrandsResults';
import CategoryResults from './CategoryResults';
import NoResults from './NoResults';
import PagesResult from './PagesResult';
import ProductResults from './ProductResults';

const GetActiveTab = (currentTab, availableTabs) => {
  if (availableTabs[currentTab].length > 0) {
    return currentTab;
  }

  for (const tab in availableTabs) {
    if (!availableTabs.hasOwnProperty(tab)) {
      continue;
    }
    if (availableTabs[tab].length > 0) {
      return tab;
    }
  }

  return 'NoResult';
};

const QuickSearchResult = ({ result, selectedItem, searchUrl, showResult, dataMenus }) => {
  const filteredResults = {
    Products: result.filter((id) => id.category === 'Produkter'),
    Brands: result.filter((id) => id.category === 'Brands'),
    Category: result.filter((id) => id.category === 'Kategorier'),
    Pages: result.filter((id) => id.category === 'Sidor'),
  };

  const [activeTab, setActiveTab] = useState('Products');
  const visibleActiveTab = GetActiveTab(activeTab, filteredResults);
  return (
    <div className="quick-search-result">
      {visibleActiveTab != 'NoResult' && (
        <div className="row">
          <div className="[ quick-search-results-tabs ] [ columns small-12 ]">
            {filteredResults.Products && filteredResults.Products.length > 0 && (
              <div
                onClick={() => setActiveTab('Products')}
                className={`[ quick-search-results-tabs__item ${
                  visibleActiveTab == 'Products' &&
                  'quick-search-results-tabs__item--active'
                } ] [ text-medium lh-2 color-grey-500 bold ]`}
              >
                {translate('quick-search.products')}
              </div>
            )}
            {filteredResults.Category && filteredResults.Category.length > 0 && (
              <div
                onClick={() => setActiveTab('Category')}
                className={`[ quick-search-results-tabs__item ${
                  visibleActiveTab == 'Category' &&
                  'quick-search-results-tabs__item--active'
                } ] [ text-medium lh-2 color-grey-500 bold ]`}
              >
                {translate('quick-search.categories')}
              </div>
            )}
            {filteredResults.Pages && filteredResults.Pages.length > 0 && (
              <div
                onClick={() => setActiveTab('Pages')}
                className={`[ quick-search-results-tabs__item ${
                  visibleActiveTab == 'Pages' &&
                  'quick-search-results-tabs__item--active'
                } ] [ text-medium lh-2 color-grey-500 bold ]`}
              >
                {translate('quick-search.pages')}
              </div>
            )}
            {filteredResults.Brands && filteredResults.Brands > 0 && (
              <div
                onClick={() => setActiveTab('Brands')}
                className={`[ quick-search-results-tabs__item ${
                  visibleActiveTab == 'Brands' &&
                  'quick-search-results-tabs__item--active'
                } ] [ text-medium lh-2 color-grey-500 bold ]`}
              >
                {translate('quick-search.brands')}
              </div>
            )}
          </div>
        </div>
      )}
      <div className="row">
        <div className="columns small-12">
          {visibleActiveTab == 'Products' && (
            <ProductResults
              filteredProducts={filteredResults.Products}
              selectedItem={selectedItem}
            />
          )}
          {visibleActiveTab == 'Category' && (
            <CategoryResults filteredCategory={filteredResults.Category} />
          )}
          {visibleActiveTab == 'Pages' && (
            <PagesResult filteredPages={filteredResults.Pages} />
          )}
          {visibleActiveTab == 'Brands' && (
            <BrandsResults filteredBrands={filteredResults.Brands} />
          )}
          {visibleActiveTab == 'NoResult' && <NoResults dataMenus={dataMenus}/>}
        </div>
      </div>

      {visibleActiveTab != 'NoResult' && (
        <div className="quick-search-result__submit-row columns">
          <a
            className="quick-search-result__submit-row--button"
            href={searchUrl}
          >
            {translate('quicksearch.show-all')}
          </a>
        </div>
      )}
    </div>
  );
};

export default QuickSearchResult;
